import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { AccountStatus } from 'dashboard/models/account-status';
import Sticker from 'design-system/components/Sticker';

const StickerContainer = styled('div')`
  display: grid;
  width: fit-content;
  align-items: center;

  gap: ${Spacing[2]};
`;

interface AccountStatusStickerProps {
  accountStatus: AccountStatus;
  disabled?: boolean;
}

const AccountStatusSticker = ({ accountStatus, disabled = false }: AccountStatusStickerProps) => {
  // TODO: add account status colors
  return (
    <StickerContainer>
      <Sticker disabled={disabled}>{accountStatus.attributes.name}</Sticker>
    </StickerContainer>
  );
};

export default AccountStatusSticker;
